/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { OAVDistributor } from "../OAVDistributor";

export class OAVDistributor__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(_OAV: string, overrides?: Overrides): Promise<OAVDistributor> {
    return super.deploy(_OAV, overrides || {}) as Promise<OAVDistributor>;
  }
  getDeployTransaction(
    _OAV: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_OAV, overrides || {});
  }
  attach(address: string): OAVDistributor {
    return super.attach(address) as OAVDistributor;
  }
  connect(signer: Signer): OAVDistributor__factory {
    return super.connect(signer) as OAVDistributor__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OAVDistributor {
    return new Contract(address, _abi, signerOrProvider) as OAVDistributor;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_OAV",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OAV",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "claimable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pauseClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_OAV",
        type: "address",
      },
    ],
    name: "setToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpauseClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "oldAddresses",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "newAddresses",
        type: "address[]",
      },
    ],
    name: "updateClaimableAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "amount",
        type: "uint256[]",
      },
    ],
    name: "updateClaimableAmounts",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
